import { render, staticRenderFns } from "./AnalyzePageConfig.vue?vue&type=template&id=db06db8c"
import script from "./AnalyzePageConfig.vue?vue&type=script&lang=js"
export * from "./AnalyzePageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports